import React, { FC } from 'react'

const SoundPackLicensePersonal: FC<{ headerHeight: string }> = ({ headerHeight }) => {
  React.useEffect(() => {
    document.title = 'Artist Sound Pack - Personal License'
  }, [])

  return (
    <iframe
      style={{ height: 'calc(100vh - ' + headerHeight + ')' }}
      src="/static/pdf/Arpeggi - Artist Sound Pack - Personal License.pdf"
    />
  )
}

export default SoundPackLicensePersonal
